import React from 'react';

interface GateForceErrorStateProps {
  onRetry: () => void;
}

interface GateForceAllHiddenStateProps {
  onResetFilters: () => void;
}

interface GateForceEmptyStateProps {
  message?: string;
}

interface GateForceNoticeProps {
  message: string;
}

export const GateForceLoadingState: React.FC = () => (
  <div
    className="absolute inset-0 flex flex-col items-center justify-center gap-2"
    data-testid="gate-force-loading"
  >
    <svg
      className="animate-spin h-8 w-8 text-rowing-blue opacity-40"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      />
    </svg>
    <p className="text-rowing-gray-400 text-sm">Loading chart data...</p>
  </div>
);

export const GateForceErrorState: React.FC<GateForceErrorStateProps> = ({ onRetry }) => (
  <div className="absolute inset-0 flex flex-col items-center justify-center text-sm text-rowing-red gap-2">
    <span>Error loading gate force data.</span>
    <button
      type="button"
      onClick={onRetry}
      className="px-3 py-1 rounded border border-rowing-red text-rowing-red hover:bg-red-50"
    >
      Retry
    </button>
  </div>
);

export const GateForceAllHiddenState: React.FC<GateForceAllHiddenStateProps> = ({
  onResetFilters,
}) => (
  <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 text-center px-4">
    <p className="text-sm text-gray-600">All rowers hidden. Reset filters.</p>
    <button
      type="button"
      onClick={onResetFilters}
      className="min-h-11 px-4 py-2 rounded-md border border-blue-200 bg-blue-50 text-blue-700 text-sm font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
    >
      Reset Filters
    </button>
  </div>
);

export const GateForceEmptyState: React.FC<GateForceEmptyStateProps> = ({ message }) => (
  <div className="absolute inset-0 flex items-center justify-center text-gray-500 text-sm text-center px-4">
    <p>{message || 'No data available for this selection.'}</p>
  </div>
);

export const GateForceNotice: React.FC<GateForceNoticeProps> = ({ message }) => (
  <div className="rounded-md border border-amber-200 bg-amber-50 px-2 py-1.5 text-xs text-amber-700">
    {message}
  </div>
);
